
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|1561|8001|9707)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
